import { POLL_TYPE } from './types.js';
import { D as DEFAULT_RICOS_COMPONENT_DATA } from './helpers-d59c72d9.js';
import { createPollData } from './createPollData.js';
import { tiptapExtensions } from './tiptap/tiptap.js';
import { getAddButtons } from './getAddButtons.js';
import { getToolbarButtons } from './getToolbarButtons.js';
import 'wix-rich-content-common/libs/imageUtils';
import 'lodash';
import 'ricos-content';
import 'ricos-schema/dist/statics/poll.defaults.json';
import './tiptap/component.js';
import 'react';
import './viewer/poll-viewer.js';
import 'wix-rich-content-editor-common/libs/EditorEventsContext';
import './viewer/poll-component.js';
import 'classnames';
import 'react-flip-move';
import 'react-measure';
import './components/rce-helpers-context/index.js';
import 'prop-types';
import './components/poll-option/index.js';
import './components/poll-option/PollGridOption.js';
import 'wix-rich-content-common/libs/Tooltip';
import './components/poll-option/PollOptionBase.js';
import './components/poll-option/types.js';
import './components/poll-context/types.js';
import './option-8d036ac1.js';
import './style-inject.es-746bb8ed.js';
import './assets/icons/NonEditableIcon.js';
import './assets/icons/CheckIcon.js';
import './components/image-upload/ImageUpload.js';
import './components/image-upload/types.js';
import './assets/icons/LoaderIcon.js';
import './assets/icons/ReplaceIcon.js';
import './components/text-field/TextField.js';
import './assets/icons/RemoveIcon.js';
import './components/poll-option/PollListOption.js';
import './components/poll-option/webview/PollListOptionWebview.js';
import './option-webview-740347b7.js';
import './components/poll-option/webview/PollGridOptionWebview.js';
import 'ricos-context';
import './dataHooks.js';
import './components/poll-header/PollHeader.js';
import './components/poll-context/PollContext.js';
import './components/voted-users/VotedUsers.js';
import 'react-modal';
import './components/voted-users/types.js';
import './VotedUsersModal-e240cd2e.js';
import 'react-infinite-scroller';
import './components/voted-users/VoterAvatar.js';
import './components/voted-users/FallbackAvatar.js';
import 'wix-rich-content-ui-components';
import './assets/icons/AddIcon.js';
import 'wix-rich-content-editor-common';
import 'ricos-types';
import './components/modals/InsertModal.js';
import './consts.js';
import 'ricos-schema';
import './components/settings/preset-selector/PollPresetSelector.js';
import './assets/icons/ListPollIcon.js';
import './assets/icons/WithImagePollIcon.js';
import './assets/icons/GridPollIcon.js';
import './assets/icons/InsertPluginIcon.js';
import './components/modals/SettingsModal.js';
import './components/settings/SettingsModal.js';
import 'wix-rich-content-common';
import './components/settings/constants.js';
import './components/settings/edit-poll-section/EditPollSection.js';
import './components/settings/layout-settings-section/LayoutSettingsSection.js';
import 'wix-rich-content-plugin-commons';
import './assets/icons/LayoutListIcon.js';
import './assets/icons/LayoutGridIcon.js';
import './components/settings/design-settings-section/DesignSettingsSection.js';
import './assets/icons/ColorIcon.js';
import './assets/icons/GradientIcon.js';
import './assets/icons/ImageIcon.js';
import './components/settings/poll-settings-section/PollSettingsSection.js';
import './toolbar/PollDesignButton.js';
import 'wix-rich-content-toolbars-ui';
import './assets/icons/DesignIcon.js';
import './toolbar/PollLayoutButton.js';
import './toolbar/PollButtonsData.js';
import './assets/icons/LayoutGridIconNew.js';
import './assets/icons/LayoutListIconNew.js';
import './toolbar/PollLayoutPanel.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const pluginPoll = (config) => {
  const pluginConfig = __spreadValues(__spreadValues({}, DEFAULT_RICOS_COMPONENT_DATA.containerData), config);
  return {
    config: pluginConfig,
    type: POLL_TYPE,
    createPluginData: createPollData,
    tiptapExtensions,
    getAddButtons: (config2, services) => getAddButtons(config2),
    toolbar: { getButtons: (config2, services) => getToolbarButtons(config2, services) }
  };
};

export { pluginPoll };
//# sourceMappingURL=editor.js.map
